import { defineComponent as _defineComponent } from 'vue'

import {
  getCurrentInstance,
  inject,
  onMounted,
  PropType,
  watch,
} from 'vue';

import { fabric } from 'fabric';
import {
  commonProps,
  FabricExposition,
  injectionKey,
} from '@/core/components/data-display/Fabric/fabric.shared';

import { useFabricObject } from '@/core/components/data-display/Fabric/fabric.hooks';
import { Deferred } from '@/utils/promise';
import { renderObject } from '@/core/components/data-display/Fabric/fabric';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkFabricText',
  props: {
  ...commonProps,
  text: {
    type: String,
    required: true,
  },
  options: {
    type: Object as PropType<fabric.ITextOptions>,
    default: () => ({}),
  },
},
  setup(__props, { expose }) {

const props = __props



const fabricInjection = inject<FabricExposition>(injectionKey);
const deferredObject = Deferred<fabric.Text>();
const vm = getCurrentInstance();

let text: fabric.Text;

useFabricObject(() => text, props);

const updateText = () => {
  const canvas = fabricInjection?.getCanvas();

  if (text && canvas) {
    text.set({
      text: props.text,
    });
    text.fire('changed');
    canvas.renderAll();
  }
};
const createObject = (): fabric.Text => {
  const object = new fabric.Text(props.text, props.options);
  object.set('strokeWidth', 0);
  return object;
};

watch(() => props.text, updateText);

onMounted(() => {
  const canvas = fabricInjection?.getCanvas();
  deferredObject.promise.then((object) => renderObject({
    object,
    canvas,
    deferredObject,
    vm,
  }));
  text = createObject();
  deferredObject.resolve(text);
});

expose({
  deferredObject,
});

return (_ctx: any,_cache: any) => {
  return null
}
}

})